/**
 * プロダクト別試用日数（Admin 管理画面表示用）
 */

export const PRODUCT_TRIAL_MIN_DAYS = 0;
export const PRODUCT_TRIAL_MAX_DAYS = 365;

export function parseProductTrialDaysOverride(value) {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return null;
  }
  const floored = Math.floor(n);
  if (floored < PRODUCT_TRIAL_MIN_DAYS || floored > PRODUCT_TRIAL_MAX_DAYS) {
    return null;
  }
  return floored;
}

export function formatTrialDaysFieldValue(value) {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  const parsed = parseProductTrialDaysOverride(value);
  return parsed === null ? '' : String(parsed);
}

/**
 * 保存前バリデーション。空欄は未設定（null）として許可。
 * @returns {{ ok: true, value: number|null } | { ok: false, error: string }}
 */
export function validateTrialDaysField(value, fieldLabel = '試用日数') {
  if (value === '' || value === null || value === undefined) {
    return { ok: true, value: null };
  }
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return { ok: false, error: `${fieldLabel}は数値で指定してください` };
  }
  const floored = Math.floor(n);
  if (floored < PRODUCT_TRIAL_MIN_DAYS || floored > PRODUCT_TRIAL_MAX_DAYS) {
    return {
      ok: false,
      error: `${fieldLabel}は ${PRODUCT_TRIAL_MIN_DAYS} 〜 ${PRODUCT_TRIAL_MAX_DAYS} の整数で指定してください`,
    };
  }
  return { ok: true, value: floored };
}

/** @deprecated validateTrialDaysField を使用 */
export function trialDaysForSave(value) {
  const result = validateTrialDaysField(value);
  if (!result.ok) {
    return null;
  }
  return result.value;
}
